import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './static-pages.magic.css.js';
import script from './static-pages.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-pages",attrs:{"part":"static-pages","data-v-test-id":"static-pages"}},[_c('magic-static-page-header',{staticClass:"header",attrs:{"part":"header","slug":_vm.contentHeaderSlug,"data-v-test-id":"header","hide-description":"","use-image-for-mobile-bg":_vm.enhancedCoversOnStaticPages,"hide-image":_vm.enhancedCoversOnStaticPages},on:{"contentLoadError":function($event){return _vm.onError()}}}),_vm._v(" "),_c('div',{staticClass:"content-section"},[_c('div',{staticClass:"navigation-wrapper"},[_c('ul',{staticClass:"list",attrs:{"part":"list"}},[_c('li',_vm._l((_vm.filteredPages),function(page){return _c('span',{key:page.id,staticClass:"text",class:{ 'is-active': _vm.selectedTab === page.slug },attrs:{"part":_vm.$p('text', { 'is-active': _vm.selectedTab === page.slug }),"data-v-test-id":"navigation-item"},on:{"click":function($event){return _vm.handleTabChange(page.slug)}}},[_vm._v("\n                        "+_vm._s(page.title)+"\n                    ")])}),0)])]),_vm._v(" "),_c('magic-static-page-content',{staticClass:"static-pages-content",attrs:{"part":"static-pages-content","slug":_vm.selectedTab,"data-v-test-id":"page-content"}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-79e37985_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-79e37985";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
